/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { EnvironmentType } from './assistant';

export const enum ReleaseStatus {
  PROCESSING = 'Processing',
  FAILED = 'Failed',
  AVAILABLE = 'Available'
}

export type Release = {
  status: ReleaseStatus;
  content: ReleaseContent;
  created: string;
  release: string;
  updated: string;
  description: string;
  linked_assistant_references: LinkedAssistantReferences[];
  environment_references?: LinkedAssistantReferences[];
  is_live: boolean;
  has_dialog: boolean;
};

export interface ReleaseContent {
  skills: SkillContent[];
}

export interface LinkedAssistantReferences {
  assistant_id?: string;
  environment_id?: string;
  name?: string;
  environment: EnvironmentType;
}

export interface EnvironmentReference {
  name: string;
  environment: EnvironmentType;
  environment_id: string;
}

export interface SkillContent {
  type: string;
  skill_id: string;
  snapshot: string;
}

export type PublishStatus = {
  is_publishing: boolean;
};
